/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

jQuery(document).ready(function($){
  // add gift wrap if checkbox is checked in cart drawer
  const add_gift_wrap = () => {
    let variant_id = $('.mini-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    let note = $('.mini-cart__gift-wrap #gift-note').val();
    var headers = new Headers({ 'Content-Type': 'application/json' });

    let variant_in_gift_cart = $('.gift-cart-variant-id').val();
  
    let updates = {
      [variant_id]: 1
    }
  
    if(variant_in_gift_cart != 0 && variant_id != variant_in_gift_cart) {
      updates = {
        ...updates,
        [variant_in_gift_cart]: 0
      };
    }
    
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: updates, attributes: { 'gift-wrapping': true, 'gift-note': note } })
    };
    fetch('/cart/update.js', request).then(async (response) => {
        setTimeout(async () => {
          const cartContent = await response.json();
          updateCartDrawerData(cartContent);
          //updateCartDrawer();
        }, 500);
    });
  }

  // add gift wrap if checkbox is checked in cart
  const add_gift_wrap_cart = () => {
    let variant_id = $('.main-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    let note = $('.main-cart__gift-wrap #gift-note').val();
    var headers = new Headers({ 'Content-Type': 'application/json' });
    let variant_in_gift_cart = $('.gift-cart-variant-id').val();
    let updates = {
      [variant_id]: 1
    }
    if(variant_in_gift_cart != 0 && variant_id != variant_in_gift_cart) {
      updates = {
        ...updates,
        [variant_in_gift_cart]: 0
      };
    }
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: updates, attributes: { 'gift-wrapping': true, 'gift-note': note } })
    };
    fetch('/cart/update.js', request).then(async (response) => {
        setTimeout(async () => {
          window.location.href = `${Shopify.routes.root}cart`;
        }, 500);
    });
  }

  // remove gift wrap if checkbox is unchecked on cart drawer
  const remove_gift_wrap = () => {
    let variant_id = $('.mini-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    var headers = new Headers({ 'Content-Type': 'application/json' });
    let note = $('#is-a-gift #gift-note').val();
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: { [variant_id]: 0 }, attributes: { 'gift-wrapping': '', 'gift-note': '' } })
    };
    fetch('/cart/update.js', request).then(async (response) => {
      setTimeout(async () => {
        const cartContent = await response.json();
        updateCartDrawerData(cartContent);
        //updateCartDrawer();
      }, 1000);
    });
  }

  // remove gift wrap if checkbox is unchecked on cart page
  const remove_gift_wrap_cart = () => {
    let variant_id = $('.main-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    var headers = new Headers({ 'Content-Type': 'application/json' });
    let note = $('#is-a-gift #gift-note').val();
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: { [variant_id]: 0 }, attributes: { 'gift-wrapping': '', 'gift-note': '' } })
    };
    fetch('/cart/update.js', request).then(async (response) => {
      setTimeout(async () => {
        window.location.href = `${Shopify.routes.root}cart`;
      }, 500);
    });
  }

  // function to remove items from cart
  const remove_item_cart = (id) => {
   jQuery.post('/cart/change.js', { id: id, quantity:0 }).then((response)=>{
     //console.log('response',response);
     location.href="/cart";
   })
  }

  // function to update cart data after performing any event
  function updateCartDrawer() {
    // Make another AJAX request to fetch the updated cart data
    fetch('/cart.js').then(async (response) => {
      const cartContent = await response.json();
      updateCartDrawerData(cartContent);
    });
  }
  
  function updateCartDrawerData(cartContent) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
      bubbles: true,
      detail: {
        cart: cartContent
      }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cartContent,
        openMiniCart: window.themeVariables.settings.cartType === "drawer"
      }
    }));
  }

  // function to show updated cart data after performing any event
  const cart_items_data = () => {
    let variantId = $('.mini-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variantId == undefined) {
      variantId = $('.gift-wrapping-variant').val();
    }
    if(variantId){
    fetch('/cart.js').then(function(response) {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Error fetching cart data');
      }
    }).then(function(cartData) {
      // Process the cart data
      var gift_wraps_in_cart = 0;
      let items = cartData.items;
      items.map((item) =>{
        let itemId = item.variant_id;
        if(itemId == variantId){
          gift_wraps_in_cart = item.quantity;
        }
      });
  
      if(cartData.attributes['gift-wrapping']) {
        if(items.length == 1 && gift_wraps_in_cart > 0){
            remove_gift_wrap();
        } else if (gift_wraps_in_cart > 1){
            add_gift_wrap();
        } 
        else if (gift_wraps_in_cart > 0 && cartData.attributes['gift-wrapping'] == ''){
            add_gift_wrap();
        } else if (gift_wraps_in_cart == 0 && cartData.attributes['gift-wrapping'] != ''){
            add_gift_wrap();
        }
    }
    })
    .catch(function(error) {
      console.log('Error:', error);
    });
    }
  }

  // function to add gift note in cart drawer
  const giftNote = (note) => {
   // console.log('note',note);
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ attributes: { 'gift-note': note } })
    };
    fetch('/cart/update.js', request).then((response) => {
      // console.log('response',response);
    });
  }

  cart_items_data();

  // submit button gift wrap mini cart
  $(document.body).on('click', '.cstm_gift_submit', function() {
    let note = $(this).closest('#mini-cart').find('.mini-cart__gift-wrap #gift-note').val();
    // if(note == '') {
    //   $(this).closest('#mini-cart').find('.mini-cart__gift-wrap #gift-note').focus();
    //   return false;
    // }
    if (!isRomanCharactersOnly(note)) {
      $('.gift_limit_field').show();
      $('.cstm_gift_submit').addClass('error');
      $(this).closest('#mini-cart').find('.mini-cart__gift-wrap #gift-note').focus();
      return false;
    } else {
      $('.gift_limit_field').hide();
      $('.cstm_gift_submit').removeClass('error');
    }
    // console.log('gift_note',gift_note);
    let giftWrap = $(this).closest('#mini-cart').find('#mini-gift-note #gift-wrapping');
   // console.log('giftWrap',giftWrap.is(':checked'),giftWrap.val());
    if(giftWrap.is(':checked') == false){
      add_gift_wrap();
    }else if (giftWrap.is(':checked')) {
      add_gift_wrap();
    }
    else {
      remove_gift_wrap();
    }
  });

  // submit button gift wrap main cart
  $(document.body).on('click', '.main-cart-cstm_gift_submit', function() {
    let note = $(this).closest('.main-cart__gift-wrap').find('#gift-note').val();
    // if(note == '') {
    //   $(this).closest('.main-cart__gift-wrap').find('#gift-note').focus();
    //   return false;
    // }
    if (!isRomanCharactersOnly(note)) {
      $('.gift_limit_field').show();
      $('.main-cart-cstm_gift_submit').addClass('error');
      $(this).closest('.main-cart__gift-wrap').find('#gift-note').focus();
      return false;
    } else {
      $('.gift_limit_field').hide();
      $('.main-cart-cstm_gift_submit').removeClass('error');
    }
    let giftWrap = $(this).closest('.main-cart__gift-wrap').find('#gift-wrapping');
    if(giftWrap.is(':checked') == false){
      add_gift_wrap_cart();
    }else if (giftWrap.is(':checked')) {
      add_gift_wrap_cart();
    }
    else {
      remove_gift_wrap_cart();
    }
  });

  function isRomanCharactersOnly(input) {
    const forbiddenCharacters = /^[\p{Script=Latin}\s€()=<>\-"\[\]@#$–%^&*_+|',;!?‽:/.{}\d\\]*$/u;
   if (forbiddenCharacters.test(input)) {
        return true; // Contains forbidden characters
    } else {
     return false;
    }
  }

  $(document.body).on('keyup', '#is-a-gift #gift-note', function(evt){
      var note = $(this).val();
      var textMax = $(this).attr('maxlength');
      var textLength = $(this).val().length;
      var textRemaining = textMax - textLength;
      $('.gift-note-count').html(textRemaining);
      if (!isRomanCharactersOnly(note)) {
        $('.gift_limit_field').show();
        $('.cstm_gift_submit, .main-cart-cstm_gift_submit').addClass('error');
      } else {
        $('.gift_limit_field').hide();
        $('.cstm_gift_submit, .main-cart-cstm_gift_submit').removeClass('error');
      }
  });

  // item remove button cart drawer
  $(document.body).on('click', '#mini-cart-form .line-item .line-item__remove-button', function(e) {
    var variant_id = $('.mini-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    let item_id = $(this).closest('.line-item').attr('variant-id');
    let gift_note = $(this).closest('#mini-cart').find('.mini-cart__gift-wrap #gift-note');
    if (item_id == variant_id) {
      gift_note.val('');
      remove_gift_wrap();
    }
  });

  // gift item remove button mini cart
  $(document.body).on('click', '.cstm_gift_remove', function(e) {
    var variant_id = $('.mini-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    let item_id = $('.gift-cart-variant-id').val();
    let gift_note = $(this).closest('#mini-cart').find('.mini-cart__gift-wrap #gift-note');
    if (item_id == variant_id) {
      gift_note.val('');
      remove_gift_wrap();
    }
  });

  // gift item remove button main cart
  $(document.body).on('click', '.main-cart-cstm_gift_remove', function(e) {
    var variant_id = $('.main-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    let item_id = $('.gift-cart-variant-id').val();
    let gift_note = $(this).closest('.main-cart__gift-wrap').find('#gift-note');
    if (item_id == variant_id) {
      gift_note.val('');
      remove_gift_wrap_cart();
    }
  });

  // item quantity selector cart drawer
  $(document.body).on('click', '#mini-cart-form .line-item .quantity-selector__button', function() {
    var variant_id = $('.mini-cart__gift-wrap #gift-wrapping').attr('vrnt_id');
    if(variant_id == undefined) {
      variant_id = $('.gift-wrapping-variant').val();
    }
    let item_id = $(this).closest('.line-item').attr('variant-id');
    let gift_note = $(this).closest('#mini-cart').find('.mini-cart__gift-wrap #gift-note');
    if (item_id == variant_id) {
      gift_note.val('');
      remove_gift_wrap();
    }
  });

  $(document.body).on('click', '.cstm_gift_close', function() {
    let gift_note = $(this).closest('#mini-cart').find('.mini-cart__gift-wrap #gift-note');
    updateCartDrawer();
  });

  $(document.body).on('click', '.main-cart-cstm_gift_close', function() {
    let gift_note = $(this).closest('.main-cart__gift-wrap').find('#gift-note');
    $('.main-cart-gift__overlay').trigger('click');
  });

  $(document.body).on('click', '#cart_line_items .line-item__remove-button', function(e) {
    e.preventDefault();
    var id = $(this).data('id');
    var itmId = $(this).closest('.line-item').attr('variant-id');
    var vrntID = $('#is-a-gift #gift-wrapping').attr('vrnt_id');
    let giftWrap = $(this).closest('.cart').find('#gift-wrapping');
    //console.log(itmId,vrntID,giftWrap,giftWrap.attr('checked'));
    if(itmId == vrntID){
      if (giftWrap.is(':checked')) {
        giftWrap.removeAttr('checked');
        //console.log('checekd',giftWrap.is(':checked'));
        remove_gift_wrap_cart();
      }
    }else {
      remove_item_cart(id);
    }
  });


  $(document.body).on('click', '.mini-cart__recommendations-inner', function (event) {
    // Ignore clicks on the scroller div
    if ($(event.target).closest('.scroller').length) return;
    if ($(window).width() >= 1000) {
      $('.drawer__overlay').trigger('click');
    }
  });
  
});

// Product Variant Text Change On Variant Change
document.addEventListener('variant:changed', function(event) {
  let variantID = event.detail.variant.id;
  let variantList = document.querySelector('variant-picker .cstm-variant-text');
  let variantListID = variantList.getAttribute('data-variantid');
  
  if(variantID == variantListID) {
    variantList.removeAttribute('hidden');
  } else {
    variantList.setAttribute('hidden', 'hidden');
  }
});

// Product Page Sticky
function getStickyHeaderOffset() {
  const documentStyles = window.getComputedStyle(document.documentElement);
 // console.log(documentStyles.getPropertyValue("--announcement-bar-height"),  'hff');
  return parseInt(documentStyles.getPropertyValue("--header-height") || 0) * parseInt(documentStyles.getPropertyValue("--enable-sticky-header") || 0) + parseInt(documentStyles.getPropertyValue("--announcement-bar-height") || 0) * parseInt(documentStyles.getPropertyValue("--enable-sticky-announcement-bar") || 0);
}

// window.addEventListener("scroll", function() {
//     const leftSection = document.querySelector('.product__media');
//     const rightSection = document.querySelector('.product__info');
    
//     const leftSectionRect = leftSection.getBoundingClientRect();
//     const leftSectionBottom = leftSectionRect.bottom;
//     const rightSectionHeight = rightSection.offsetHeight;
//     const viewportHeight = window.innerHeight;

//     // Add 'sticky' class based on the scroll position
//     rightSection.classList.remove('sticky');
//     if (leftSectionBottom > rightSectionHeight) {
//        rightSection.classList.add('sticky');
//     } else {
//         rightSection.classList.remove('sticky');
//     }
// });

// Select the announcement section element and the target div
const announcementSection = document.querySelector('.announcement-bar');
function adjustSectionHeight() {
  const productsection = document.querySelector('.product');
  const productInfo = document.querySelector('.product__info');
  const productMedia = document.querySelector(".product__media");

  if(!productInfo) {
    return false;
  }
  let initialHeight = 0;
  if (announcementSection) {
    // Initial height of the section
    initialHeight = announcementSection.getBoundingClientRect().height;

    // Add the class once if necessary
    // productInfo.classList.add("section-maxheight");
  }

  const scrollY = window.scrollY || window.pageYOffset;

  const mediaOffsetTop = productMedia.offsetTop;
  const mediaHeight = productMedia.offsetHeight;
  const mediaHalfHeight = mediaHeight / 2;

  
    
    // Calculate the new height, ensuring it does not exceed the initial height
    let currentHeight = Math.max(0, initialHeight - scrollY);
  

    // Apply the calculated height to the target div's CSS height
    productsection.style.setProperty('--current-height', `${currentHeight}px`);
}

adjustSectionHeight();
// Set initial height on load for the target div
//productsection.style.setProperty('--current-height', `${initialHeight}px`);

// Add scroll event listener to adjust the height on scroll
window.addEventListener('scroll', adjustSectionHeight);
function fetchectionHeight() {
  const windowHeight = window.innerHeight;
  const productMedia = document.querySelector(".product__media-list-wrapper");
  const productInfo = document.querySelector('.product__info');
  if(!productInfo) {
    return false;
  }
  const mediaHeight = productMedia.offsetHeight;
  //console.log(windowHeight, 'windowHeight', mediaHeight, 'mediaHeight');
  if(mediaHeight < windowHeight) {
    productInfo.classList.add("fixed");
  } else {
    productInfo.classList.remove("fixed");
  }
}
fetchectionHeight();
window.addEventListener('resize', fetchectionHeight);